import React from 'react'
import SatisfiedCustomer from '../../Assets/About/verified.png'
import CountUp from 'react-countup';
import { useIntersectionObserver } from "../../Assets/CustomHook/CustomHook";
import img1 from '../../Assets/About/trustworthiness.png'
import img2 from '../../Assets/About/thumb-up.png'
import img3 from '../../Assets/About/costumer.png'
const LookOurNumbers = () => {
    const [ref, isVisible] = useIntersectionObserver({
        threshold: 0.1,
        triggerOnce: true,
      });
    return (
        <div  ref={ref}>
            <h1  className="text-3xl lg:text-5xl font-semibold text-center mb-4 mt-16" data-aos="fade-up">Look at Our Numbers</h1>

            <div className='grid lg:grid-cols-4  md:grid-cols-2 grid-cols-1 px-4 md:px-16 justify-around mt-10 gap-10'  data-aos="fade-up-right">
                <div className='flex flex-col items-center justify-center space-y-5' data-aos="fade-right">
                    <img src={SatisfiedCustomer} alt='Satisfied Customer' />
                    <h1 className='text-4xl md:text-5xl text-center'> {isVisible && <CountUp start={0} end={100} duration={5} />}+ </h1>
                    <p className='text-lg md:text-xl text-center'>Happy clients</p>
                </div>

                <div  data-aos="fade-up-left" className=' flex flex-col items-center justify-center space-y-5'>
                    <img src={img1} alt='Food Delivered'/>
                    <h1 className='text-4xl md:text-5xl text-center'>{isVisible && <CountUp start={0} end={100} duration={5} />}+ </h1>
                    <p className='text-lg md:text-xl text-center'>Satisfied Customer</p>
                </div>

                <div data-aos="fade-down-right" className=' flex flex-col items-center justify-center space-y-5' >
                    <img src={img2} alt='Trusted Partner' />
                    <h1 className='text-4xl md:text-5xl text-center'>{isVisible && <CountUp start={0} end={55} duration={5} />}+ </h1>
                    <p className='text-lg md:text-xl text-center'>Trusted Partners</p>
                </div>

                <div data-aos="fade-up-left" className='flex flex-col items-center justify-center space-y-5'>
                    <img src={img3} alt='Experienced Driver' />
                    <h1 className='text-4xl md:text-5xl text-center'>{isVisible && <CountUp start={0} end={150} duration={5} />}+ </h1>
                    <p className='text-lg md:text-xl text-center'>project completion</p>
                </div>
            </div>
        </div>
    )
}

export default LookOurNumbers